import { Link } from '../lib/routerCompat';

export default function TermsView(): JSX.Element {
  return (
    <div className="legal-page">
      <Link to="/" className="legal-back">
        ← Back to PitchVault
      </Link>
      <h1>Terms of Service</h1>
      <p className="legal-updated">Last updated: July 24, 2026</p>

      <p>
        These terms govern your use of PitchVault, a marketplace connecting brands with content
        creators. By joining the waitlist or using the platform, you agree to them.
      </p>

      <h2>The platform</h2>
      <ul>
        <li>Brands post campaigns with a minimum budget of $250.</li>
        <li>Creators pitch, deliver content, and are paid through the platform.</li>
        <li>
          All communication, delivery, and payment for deals initiated on PitchVault must stay on
          PitchVault. Off-platform dealing may result in account termination.
        </li>
      </ul>

      <h2>Payments</h2>
      <p>
        Campaign funds are held until the brand approves delivery, then released to the creator
        minus the platform commission. Creator subscriptions are billed monthly or annually and can
        be cancelled anytime, effective at the end of the billing period.
      </p>

      <h2>Content and conduct</h2>
      <ul>
        <li>You must have the rights to any content you upload or deliver.</li>
        <li>No unlawful, deceptive, or infringing content or behavior.</li>
        <li>We may suspend accounts that violate these terms or harm the marketplace.</li>
      </ul>

      <h2>Disclaimers</h2>
      <p>
        PitchVault is provided &ldquo;as is.&rdquo; We facilitate deals between independent brands
        and creators and are not a party to the underlying creative engagements beyond the platform
        services we provide.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these terms as the product evolves; material changes will be announced. Your
        continued use after changes take effect constitutes acceptance.
      </p>

      <h2>Contact</h2>
      <p>
        Questions? Reach us via{' '}
        <a href="https://www.gigadude.com" target="_blank" rel="noopener noreferrer">
          gigadude
        </a>
        .
      </p>
    </div>
  );
}
